import React from "react";

function Createorder({ colorCode = "" }) {
  return (
    <svg className="MuiSvgIcon-root" viewBox="0 0 32 32" fill="none">
      <line
        x1="16"
        y1="6"
        x2="16"
        y2="27"
        stroke={colorCode}
        strokeWidth="2"
        strokeLinecap="round"
      ></line>
      <line
        x1="5"
        y1="16"
        x2="26"
        y2="16"
        stroke={colorCode}
        strokeWidth="2"
        strokeLinecap="round"
      ></line>
    </svg>
  );
}

export default Createorder;
